import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamily } from "@clockwise/web-commons/src/styles/type.styles";

const container: CSSProperties = {
  flex: 1,
};

const menuPaper: CSSProperties = {
  maxWidth: 500,
};

const menuItemLabel: CSSProperties = {
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const largeSelect: CSSProperties = {
  fontFamily,
  fontSize: 32,
  lineHeight: 1,
  color: greys.slate,
  textDecoration: "underline",
  textDecorationStyle: "dashed",
};

const inlineSelect: CSSProperties = {
  fontFamily,
  fontSize: 14,
  fontWeight: "bold",
  paddingLeft: 5,
};

export const styles = {
  container,
  menuPaper,
  menuItemLabel,
  largeSelect,
  inlineSelect,
};
